module.exports = __webpack_public_path__ + "static/media/Song Of Ice And Fire.8d08e0ac.png";